module.exports = __webpack_public_path__ + "static/media/arrowUp.39b1867c.svg";